import type { $Fetch } from 'nitropack';
import type { BFFResponse } from '~/types/BFFResponse';
import type { Customer } from '~/types/GraphQL';

export default ($fetch: $Fetch) => {
  const register = async (body: any) => $fetch<BFFResponse<Customer>>('/customers', { method: 'POST', body });
  const deleteUserProfile = async () => $fetch<BFFResponse<unknown>>('/customers', { method: 'DELETE' });
  const requestPassword = async (body: any) => $fetch<BFFResponse<unknown>>('/customers/requestPassword', { method: 'POST', body });

  const authenticate = async (redirectTo: string, rememberMe: boolean) => {
    const { data: redirectUrl } = await $fetch<BFFResponse<string>>('/customers/signin', { query: { redirectTo: redirectTo, rememberMe: rememberMe } });

    if (import.meta.client && redirectUrl) {
      window.location.href = redirectUrl;
    }
  };
  const authorize = async (code: string) => $fetch<BFFResponse<unknown>>('/customers/authorize', { query: { code } });

  const logout = async () => {
    const { data: redirectUrl } = await $fetch<BFFResponse<string | undefined>>('/customers/logout');

    if (import.meta.client && redirectUrl) {
      window.location.href = redirectUrl;
    }
  };

  return {
    register,
    requestPassword,
    deleteUserProfile,

    // SSO
    logout,
    authorize,
    authenticate,
  };
};
